import type { Project } from "../../api/models";

export const getProjectGroupIdentity = (project: Project, unassignedLabel: string): { key: string; locationId: string | null; locationName: string } => {
    if (project.organization_link_status === "needs_assignment") {
        return { key: "organization:needs-assignment", locationId: null, locationName: "Needs assignment" };
    }
    if (project.organization_id && project.unit_id) {
        const unitName = project.unit_name || project.location_name || project.unit_id;
        const businessAreaName = project.business_area_name || "Business Area";
        return {
            key: `org:${project.organization_id}:unit:${project.unit_id}`,
            locationId: project.unit_id,
            locationName: `${businessAreaName} · ${unitName}`
        };
    }
    const locationName = project.location_name || unassignedLabel;
    const locationId = project.location_id || null;
    return {
        key: locationId ? `loc:${locationId}` : `name:${locationName}`,
        locationId,
        locationName
    };
};
